// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from '@/api/http'
import dsBridge from '@/api/dsbridge.js'
import 'lib-flexible/flexible.js'
import api from '@/api/api'
import store from '@/store/index.js'
import VueTouch from 'vue-touch'

import { Toast ,Popup ,Button ,DropdownMenu,DropdownItem ,Loading,Search,Area,Swipe, SwipeItem,Lazyload , Tab, Tabs} from 'vant' //已经引入,需要时用

Vue.use(Toast).use(Popup).use(Button).use(DropdownMenu).use(DropdownItem).use(Loading).use(Search).use(Lazyload).use(Area).use(VueTouch, {name: 'v-touch'}).use(Swipe).use(SwipeItem).use(Tab).use(Tabs);


Vue.config.productionTip = false
Vue.prototype.$axios = http     //封装的axios
Vue.prototype.$dsBridge = dsBridge   //封装的dsBridge
Vue.prototype.$api = api     //封装的axios
Vue.prototype.$imgUrls = 'http://300w.oss-cn-shenzhen.aliyuncs.com/'    //图片地址 https://dc300.netwin.cn/pckm/static/image/ (正式)
Vue.prototype.$newimgUrls = 'http://300w.oss-cn-shenzhen.aliyuncs.com/'    //oss地址
Vue.prototype.$desc = '科学疫情防范，你该知道的都在这里!'

var appVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js